import actions from './actions'

const default_avatar = require('../../resource/image/defaultUser.png')

const defaultUser = {
    display_name: '',
    organ_id: 0,
    password: '',
    position: 1,
    tier_id: 90,
    user_name: '',
    status: 1,
    avatar: '',
    uid: -1,
    rank_id: 0,
}

const initState = {
    // main data
    users: [],
    currentUser: defaultUser,
    isLoading: false,
    roles: [],
    textSearch: '',
    lastTextSearch: '',

    // modal state
    modalShowCurrentUserInfoState: false,
    modalConfirmDeletState: false,
    modalConfirmBanState: false,
    modalResetPasswordState: false,
    newPassword: '',

    // cache
    _status: 0,
    avatar_file: null,

    // pagint
    numberOfPage: 8,
    total: 0,
    currentPage: 1,
    isAddNew: false,
    default_avatar: default_avatar
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.ADD_NEW_USER:
            return {
                ...state,
                ...{
                    isAddNew: action.payload.bool,
                },
            }
        case actions.type.GET_LIST_USERS:
            return {
                ...state,
                ...{
                    isLoading: false,
                    avatar_file: null,
                },
            }

        case actions.type.GET_LIST_USERS_SUCCESS:
            return {
                ...state,
                ...{
                    users: action.payload.users,
                },
            }

        case actions.type.PRE_ADD_USER:
            return {
                ...state,
                ...{
                    currentUser: defaultUser,
                    avatar_file: null,
                },
            }

        case actions.type.SET_INIT_STATE:
            return initState

        case actions.type.DELETE_USER:
            return state

        case actions.type.BAN_USER:
            return state

        case actions.type.SAVE_CURRENT_USER:
            return state

        case actions.type.GET_CURRENT_USER:
            return state

        case actions.type.UPDATE_CURRENT_USER:
            return {
                ...state,
                ...{
                    currentUser: {
                        ...state.currentUser,
                        ...action.payload.user,
                    },
                },
            }

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.SHOW_MODAL_CURRENT_USER_INFO:
            return {
                ...state,
                ...{
                    modalShowCurrentUserInfoState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_USER_INFO:
            return {
                ...state,
                ...{
                    modalShowCurrentUserInfoState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_USER:
            return {
                ...state,
                ...{
                    modalConfirmDeletState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_USER:
            return {
                ...state,
                ...{
                    modalConfirmDeletState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_BAN_USER:
            return {
                ...state,
                ...{
                    modalConfirmBanState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_BAN_USER:
            return {
                ...state,
                ...{
                    modalConfirmBanState: false,
                },
            }

        case actions.type.UPDATE_AVATAR_FILE:
            return {
                ...state,
                ...{
                    avatar_file: action.payload.file,
                },
            }

        case actions.type.CHANGE_NUMBER_OF_PAGE:
            return {
                ...state,
                ...{
                    numberOfPage: action.payload.numberOfPage,
                    currentPage: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    currentPage: action.payload.pageIndex,
                },
            }

        case actions.type.GET_LIST_ROLES:
            return state

        case actions.type.GET_LIST_ROLES_SUCCESS:
            return {
                ...state,
                ...{
                    roles: action.payload.roles,
                },
            }

        case actions.type.SHOW_MODAL_RESET_PASSWORD:
            return {
                ...state,
                ...{
                    modalResetPasswordState: true,
                    newPassword: '',
                },
            }

        case actions.type.DISMISSS_MODAL_RESET_PASSWORD:
            return {
                ...state,
                ...{
                    modalResetPasswordState: false,
                    newPassword: '',
                },
            }

        case actions.type.RESET_PASSWORD_USER:
            return {
                ...state,
            }

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch,
                },
            }

        case actions.type.SEARCH_USER:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch,
                },
            }

        default:
            return state
    }
}

export default reducer
export { default_avatar }
